<template>
	<div v-cloak class="solution">
		<div class="banner">
			<div class="">
				<h5>关于我们</h5>
				<p>专注于精神心理类全疾病周期的非药物AI数字诊疗技术</p>
			</div>
			<img src="@/assets/img_guanyu_women_banner.png" alt="" />
			<img src="@/assets/img_gunyu_women_banner.png" alt="" class="small" />
		</div>

		<div class="container bgColor">
			<div class="content aboutusBox">
				<img src="@/assets/img_guanyu_women_gongsi_jianjie.png" alt="" class="big" />
				<div class="right">
					<div class="title">公司简介</div>
					<p>
						脑结构公司座落在人文历史底蕴厚重，医疗科研资源丰富的南京市鼓楼区。公司依托精神医学国际顶级科学家科研能力和成果，集结国内外高层次人才队伍，专注于精神心理类疾病非药物治疗的前沿技术及产品的开发。
					</p>
					<p>
						公司把成为医疗行业领先的研发型企业，精神心理类疾病精准诊疗技术领导者，做为发展愿景，致力于研发覆盖精神心理类疾病全周期的AI数字诊疗技术，赋能行业用户，造福病患与社会。
					</p>
				</div>
				<img src="@/assets/img_guanyu_women_gongsi_jianjie.png" alt="" class="small" />
			</div>
		</div>
		<div class="container">
			<div class="content aboutusBox">
				<div class="right">
					<div class="title">联系我们</div>
					<span>地址：</span>
					<em>南京市鼓楼区中央北路73号1幢312-183室</em>
					<span>电话：</span>
					<em>+86-13245888380</em>
					<span>技术支持：</span>
					<em>support@braintechnet.com</em>
					<span>邮箱：</span>
					<em>info@braintechnet.com</em>
				</div>
				<img src="@/assets/icon_lianxiwomen_location.png" alt="" />
			</div>
		</div>
	</div>
</template>

<script>
import { GlobalMixin } from '@/util/globalMixin';
export default {
	name: 'Footer',
	mixins: [GlobalMixin]
};
</script>

<style scoped lang="less">
.bgColor {
	background: #f2f6f9;
}

.title {
	text-align: left;
	margin-bottom: 53px;
}

.title::after {
	left: 0;
	margin: 0;
}

.small {
	display: none;
}

.aboutusBox {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 117px 0;

	img {
		width: 700px;
		height: 466px;
	}

	.right {
		width: 464px;
		font-size: 16px;
		color: #8e8e8e;

		p {
			margin-top: 10px;
			line-height: 36px;
		}

		span {
			display: block;
			font-size: 16px;
			color: #01668b;
			line-height: 30px;
			margin-top: 12px;
		}

		em {
			display: block;
			font-style: inherit;
			color: #262626;
			font-size: 16px;
		}
	}
}

@media (max-width: 768px) {
	.big {
		display: none !important;
	}

	.small {
		display: block;
	}

	.aboutusBox {
		display: block;
		padding: 65px 0;

		img {
			width: 90%;
			height: auto;
			display: block;
			margin: 65px auto 0;
		}

		.right {
			width: 90%;
			margin: 0 auto;

			p {
				// text-indent: 32px;
				text-align: justify;
				margin-bottom: 35px;
			}

			.title {
				width: 100%;
				text-align: center;

				&::after {
					left: 50%;
					margin-left: -54px !important;
				}
			}

			span {
				margin-top: 30px;
			}
		}
	}
}
</style>
